import InfantMeatsProduct from 'models/InfantMeatsProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: 'Beech-Nut', label: 'Beech-Nut' },
  { value: 'Early On', label: 'Early On' },
  { value: "Earth's Best", label: "Earth's Best" },
  { value: 'Gerber', label: 'Gerber' },
  { value: "Mom's Natural Choice", label: "Mom's Natural Choice" },
  { value: 'O Organics', label: 'O Organics' },
  { value: "Raley's Organic", label: "Raley's Organic" },
  { value: 'Tippy Toes', label: 'Tippy Toes' },
  { value: 'Tippy Toes Organic', label: 'Tippy Toes Organic' },
  { value: 'Wild Harvest', label: 'Wild Harvest' },
  { value: 'Yummy Naturals', label: 'Yummy Naturals' },
]

export const packagingInitialState = {
  category: InfantMeatsProduct.category,
  subCategory: InfantMeatsProduct.subCategory,
  PackageType: {
    value: '',
    label: 'Package Type',
  },
  PacketSize: '2.5 ounces only',
  MultiPackageType: false,
  MultiPackageCount: '',
  Organic: false,
  NoAdditionalIngredients: false,
}

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Jar', label: 'Jar' },
  { value: 'Plastic', label: 'Plastic' },
]
